import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import DataTable from "react-data-table-component";
import { customTableStylesForSummery } from "../../common/customTableStyles";
import {
  getDiscountSettingList,
  getMasterCountryList,
  insertDiscountSetting,
} from "../../../api/api";

const countrySelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "42px",
    borderRadius: "0.375rem",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#696cff"
      : state.isFocused
        ? "rgba(105, 108, 255, 0.12)"
        : "#fff",
    color: state.isSelected ? "#fff" : "#4b5563",
  }),
  menu: (base) => ({ ...base, zIndex: 20 }),
};

const parsePgArray = (value) => {
  if (!value) return "";
  return value
    .replace(/[{}"]/g, "")
    .split(",")
    .filter(Boolean)
    .join(", ");
};

const toPgArray = (values) => `{${values.map((v) => `"${v}"`).join(",")}}`;

const DiscountSetting = () => {
  const { id } = useParams();

  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const [discountList, setDiscountList] = useState([]);
  // const [pending, setPending] = useState(true);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  const [formData, setFormData] = useState({
    minpacket: "",
    holdtime: "",
    percentage: "",
    senderIds: "",
    deliveryRatio: "",
    failRatio: "",
    status: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const countryOptions = countryList.map((items) => ({
    value: items.country_code,
    label: `${items.country_name} (${items.country_code})`,
  }));

  const getDiscountSetting = () => {
    getDiscountSettingList(id).then((res) => {
      if (res.data.success === true) {
        setDiscountList(res.data.data);
        // setPending(false);
      } 
      else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
        setTimeout(() => {
           seterror({ errarStatus: true});
        },3000)
        // setPending(false);
      }
    });
  };

  useEffect(() => {
    getDiscountSetting();
    getMasterCountryList().then((res) => {
      if (res.data.success === true) {
        setCountryList(res.data.data);
      } else {
        setCountryList([]);
      }
    });
  }, []);

  useEffect(() => {
    if (!id || !discountList.length) return;
    const existing = discountList.find((item) => item.system_id === id);
    if (!existing) return;
    

    setFormData({
      minpacket: existing.minpacket ? String(existing.minpacket) : "",
      holdtime: existing.holdtime ? String(existing.holdtime) : "",
      percentage: existing.percentage ? String(existing.percentage) : "",
      senderIds: parsePgArray(existing.sender_json),
      status: String(existing.status),
      deliveryRatio:
        existing.delivery_ratio_percentage !== undefined &&
          existing.delivery_ratio_percentage !== null
          ? String(existing.delivery_ratio_percentage)
          : "",
      failRatio:
        existing.fail_ratio_percentage !== undefined &&
          existing.fail_ratio_percentage !== null
          ? String(existing.fail_ratio_percentage)
          : "",
    });

    const existingCountryCodes = parsePgArray(existing.country_codejson)
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
    setSelectedCountries(
      existingCountryCodes.map((code) => {
        const match = countryList.find(
          (country) => country.country_code === code
        );
        return match
          ? {
            value: match.country_code,
            label: `${match.country_name} (${match.country_code})`,
          }
          : { value: code, label: code };
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountList, id, countryList]);

  const handleMinpacketChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, minpacket: value }));
  };

  const handleHoldTimeChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, holdtime: value }));
  };

  const handleHoldTimeBlur = () => {
    setFormData((prev) => ({
      ...prev,
      holdtime:
        prev.holdtime && parseInt(prev.holdtime, 10) < 5
          ? "5"
          : prev.holdtime,
    }));
  };

  const handlePercentageChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, percentage: value }));
  };

  const handleSenderIdsChange = (e) => {
    setFormData((prev) => ({ ...prev, senderIds: e.target.value }));
  };

  const handleStatusChange = (e) => {
    setFormData((prev) => ({ ...prev, status: e.target.value }));
  };

  const handleDeliveryRatioChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      setFormData((prev) => ({ ...prev, deliveryRatio: "", failRatio: "" }));
      return;
    }
    const value = Math.min(parseInt(raw, 10), 100);
    setFormData((prev) => ({
      ...prev,
      deliveryRatio: String(value),
      failRatio: String(100 - value),
    }));
  };

  const handleFailRatioChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      setFormData((prev) => ({ ...prev, deliveryRatio: "", failRatio: "" }));
      return;
    }
    const value = Math.min(parseInt(raw, 10), 100);
    setFormData((prev) => ({
      ...prev,
      failRatio: String(value),
      deliveryRatio: String(100 - value),
    }));
  };

  const submitHandler = () => {
    seterror({ errarStatus: false });
    setIsSubmitting(true);

    const payload = {
      system_id: id,
      minpacket: parseInt(formData.minpacket || 0, 10),
      holdtime: parseInt(formData.holdtime || 0, 10),
      percentage: parseInt(formData.percentage || 0, 10),
      delivery_ratio_percentage: parseInt(formData.deliveryRatio || 0, 10),
      fail_ratio_percentage: parseInt(formData.failRatio || 0, 10),
      status: parseInt(formData.status),
      sender_json: toPgArray(
        formData.senderIds
          .split(",")
          .map((senderId) => senderId.trim())
          .filter(Boolean)
      ),
      country_codejson: toPgArray(
        selectedCountries.map((option) => option.value)
      ),
    };

    insertDiscountSetting(payload).then((res) => {
      setIsSubmitting(false);
      if (res.data.success === true) {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-success",
        });
        setTimeout(() => {
          seterror({
            errarStatus: false
          })
        },5000)
        getDiscountSetting();
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
      }
    });
  };

  const columns = [
    {
      name: "System ID",
      selector: (row) => row.system_id,
      sortable: true,
    },
    {
      name: "Min Count",
      selector: (row) => row.minpacket,
      sortable: true,
    },
    {
      name: "Hold Time",
      selector: (row) => row.holdtime,
      sortable: true,
    },
    {
      name: "Percentage",
      selector: (row) => row.percentage,
      sortable: true,
    },
    {
      name: "Delivery Ratio %",
      selector: (row) => row.delivery_ratio_percentage,
      sortable: true,
    },
    {
      name: "Fail Ratio %",
      selector: (row) => row.fail_ratio_percentage,
      sortable: true,
    },
    {
      name: "Sender IDs",
      selector: (row) => parsePgArray(row.sender_json),
      wrap: true,
    },
    {
      name: "Country Codes",
      selector: (row) => parsePgArray(row.country_codejson),
      wrap: true,
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                </div>
              ) : null}

              <div className="card mb-4">
                <h5 className="card-header d-flex justify-content-between align-items-center">
                  Add Discount Setting
                  <Link to="/admin/user-list" className="btn btn-primary btn-sm">
                    <FontAwesomeIcon icon={faArrowLeft} /> Go Back
                  </Link>
                </h5>
                <hr className="m-0" />
                <div className="card-body">
                  <div className="row gy-3">
                    <div className="col-md-3">
                      <label className="form-label">Username</label>
                      <input
                        type="text"
                        className="form-control"
                        value={id}
                        disabled
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">
                        Minimum Count
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter minimum count"
                        value={formData.minpacket}
                        onChange={handleMinpacketChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Hold Time (in sec)</label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Minimum 5"
                        value={formData.holdtime}
                        onChange={handleHoldTimeChange}
                        onBlur={handleHoldTimeBlur}
                      />
                      <div className="form-text text-info">
                        Hold time cannot be less than 5 sec.
                      </div>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">Percentage</label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter percentage"
                        value={formData.percentage}
                        onChange={handlePercentageChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Country</label>
                      <Select
                        isMulti
                        isSearchable
                        closeMenuOnSelect={false}
                        options={countryOptions}
                        value={selectedCountries}
                        onChange={(selected) =>
                          setSelectedCountries(selected || [])
                        }
                        placeholder="Select countries"
                        noOptionsMessage={() => "No countries found"}
                        styles={countrySelectStyles}
                        classNamePrefix="country-select"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Sender ID</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Example : 1234, 5678, 9810"
                        value={formData.senderIds}
                        onChange={handleSenderIdsChange}
                      />
                      <div className="form-text text-info">
                        Enter multiple sender IDs separated by commas.
                      </div>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">
                        Delivery Percentage Ratio
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter Delivery Percentage Ratio"
                        value={formData.deliveryRatio}
                        onChange={handleDeliveryRatioChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">
                        Failed Percentage Ratio
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter Failed Percentage Ratio"
                        value={formData.failRatio}
                        onChange={handleFailRatioChange}
                      />
                      <div className="form-text text-info">
                        Delivery and Failed ratio always add up to 100.
                      </div>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">
                        Status
                      </label>
                      {/* <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="Enter Failed Percentage Ratio"
                        value={formData.failRatio}
                        onChange={handleFailRatioChange}
                      /> */}
                      <select className="form-control" value={formData.status} onChange={handleStatusChange}>
                        <option value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                      {/* <div className="form-text text-info">
                        Delivery and Failed ratio always add up to 100.
                      </div> */}
                    </div>

                    <div className="col-md-12 text-right">
                      <button
                        type="button"
                        onClick={submitHandler}
                        disabled={isSubmitting}
                        className="btn btn-primary mt-3"
                      >
                        {isSubmitting
                          ? discountList.length > 0
                            ? "Updating..."
                            : "Saving..."
                          : discountList.length > 0
                            ? "Update"
                            : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="card pb-5">
                <h5 className="card-header">Discount Setting</h5>
                <DataTable
                  pagination
                  handleSort
                  columns={columns}
                  data={discountList}
                  progressPending={pending}
                  customStyles={customTableStylesForSummery}
                  noDataComponent="No Discount Setting Found"
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountSetting;
